import {takeEvery} from 'redux-saga/effects'
import {GET_MODULE_NAMES} from 'setup/redux/Actions/ModuleNames/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_MODULE_NAMES, fetchData)
}

export default dataSaga
